import {FormErrors} from "./FormErrors";

export class Form {

    /**
     * Create a new Form instance
     *
     * @param {object} attributes
     */
    constructor(attributes) {
        this.originalAttributes = attributes;

        for (let attribute in attributes) {
            this[attribute] = attributes[attribute];
        }

        this.errors = new FormErrors();
        this.isRequesting = false;
    }

    /**
     * Set default values for the Form attributes
     *
     * @param attributes
     */
    setDefaultValues(attributes) {
        for (let attribute in this.originalAttributes) {
            if (typeof attributes[attribute] !== 'undefined')
                this[attribute] = attributes[attribute];
        }
    }

    /**
     * Fetch all relevant data for the form.
     *
     * @returns {{}}
     */
    all() {
        let attributes = {};

        for (let attribute in this.originalAttributes) {
            attributes[attribute] = this[attribute];
        }

        return attributes;
    }

    /**
     * Clear the form attributes.
     */
    clear(attribute) {
        if (attribute) {
            this[attribute] = this.originalAttributes[attribute];

            return;
        }

        for (let attribute in this.originalAttributes) {
            this[attribute] = this.originalAttributes[attribute];
        }
    }

    /**
     * Send a POST request to the given URL.
     * .
     * @param {string} url
     */
    post(url) {
        return this.submit('POST', url);
    }

    /**
     * Send a POST request to the given URL.
     * .
     * @param {string} url
     */
    upload(url) {
        return this.submit('POST', url, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    /**
     * Send a PUT request to the given URL.
     * .
     * @param {string} url
     */
    put(url) {
        return this.submit('PUT', url);
    }


    /**
     * Send a PATCH request to the given URL.
     * .
     * @param {string} url
     */
    patch(url) {
        return this.submit('PATCH', url);
    }

    /**
     * Send a DELETE request to the given URL.
     * .
     * @param {string} url
     */
    delete(url) {
        return this.submit('DELETE', url);
    }

    /**
     * Submit the form
     *
     * @param {string} method
     * @param {string} url
     * @param {Object} options
     * @param {Boolean|Object} specificData
     */
    submit(method, url, options = {}, specificData = false) {
        if (this.isRequesting) {
            return Promise.reject(new Error('Form is already being submitted'));
        }

        this.isRequesting = true;

        return new Promise((resolve, reject) => {
            axios[method.toLowerCase()](url, specificData ? specificData : this.all(), options)
                .then(response => {
                    this.onSuccess(response.data);

                    resolve(response.data);
                })
                .catch(error => {
                    if (error.response && error.response.status === 422) {
                        this.onFail(error.response.data);
                    }
                    this.isRequesting = false;

                    reject(error);
                })
        })
    }

    /**
     * Handle form attributes resetting
     */
    reset() {
        this.clear();
        this.errors.clear(null);
    }

    /**
     * Handle a successful form submission.
     *
     * @param {object} data
     */
    onSuccess(data) {
        // this.reset();
        this.isRequesting = false;
    }

    /**
     * Handle a failed form submission.
     *
     * @param {object} data
     */
    onFail(data) {
        this.errors.set(data.errors);
    }
}
